import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageUsAll = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      imageUsAll: file(relativePath: { eq: "somikset.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(data.imageUsAll)}
      className={className}
      imgStyle={{ objectPosition: " center center", objectFit: "cover" }}
    />
  )
}

export default ImageUsAll
